import get from 'lodash/get';
import {
  GET_RIGHT_SIDE_DATA,
  GET_RIGHT_SIDE_DATA_SUCCESS,
  GET_RIGHT_SIDE_DATA_FAILURE,
} from '../../actions/landingPage/constants';

const INITIAL_STATE = {
  fetching: false,
  data: [],
};

export default function rightSideData(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_RIGHT_SIDE_DATA:
      return {
        ...state,
        fetching: true,
      };
    case GET_RIGHT_SIDE_DATA_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: get(action, 'payload.data', []),
      };
    case GET_RIGHT_SIDE_DATA_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMsg: action.error,
      };

    default:
      return state;
  }
}
